import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ExamLocationService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class ResetExamLocationFormGuard
  implements CanActivate
{
  constructor(private service: ExamLocationService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return new Promise<boolean>((resolve) => {
      this.service.formState.item =
        ExamLocationService.factoryItem();
      resolve(true);
    });
  }
}
